/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export {LocalizationSelect} from './LocalizationSelect';

export {focusInput} from './focusInput';
export {getTranslationInput} from './getTranslationInput';
export {handleInputLengthError, showInputError} from './handleInputError';
export {registerLocalizedInput} from './registerLocalizedInput';
export {registerUnlocalizedInput} from './registerUnlocalizedInput';
export {updateDLVideo} from './updateDLVideo';
export {openCMSFileSelectorModal} from '@liferay/frontend-js-item-selector-web';

export {localStorage} from 'frontend-js-web';
